module.exports = __webpack_public_path__ + "img/mario-galaxy-render-7.39f5c7a4.png";